export const INITIALIZE_APPLICATION = 'INITIALIZE_APPLICATION'

//Change Password
export const INIT_CHANGE_PASSWORD = 'INIT_CHANGE_PASSWORD'
export const PREPARE_CHANGE_PASSWORD = 'PREPARE_CHANGE_PASSWORD'
export const PREPARE_CHANGE_PASSWORD_FAILED = 'PREPARE_CHANGE_PASSWORD_FAILED'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const CHANGE_PASSWORD_SUCCEEDED = 'CHANGE_PASSWORD_SUCCEEDED'
export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED'
export const FINISH_CHANGE_PASSWORD = 'FINISH_CHANGE_PASSWORD'
export const FINISH_CHANGE_PASSWORD_SUCCEEDED =
  'FINISH_CHANGE_PASSWORD_SUCCEEDED'
export const FINISH_CHANGE_PASSWORD_FAILED = 'FINISH_CHANGE_PASSWORD_FAILED'
export const SUBMIT_CHANGE_PASSWORD = 'SUBMIT_CHANGE_PASSWORD'
//Reset Password
export const SUBMIT_PASSWORD_RESET_CONFIRMATION =
  'SUBMIT_PASSWORD_RESET_CONFIRMATION'
export const SUBMIT_PASSWORD_RESET_CONFIRMATION_SUCCEEDED =
  'ACTION_FORM_SUBMIT_SUCCEEDED'
export const SUBMIT_PASSWORD_RESET_CONFIRMATION_FAILED =
  'ACTION_FORM_SUBMIT_FAILED'
export const SUBMIT_PASSWORD_RESET = 'SUBMIT_PASSWORD_RESET'
export const SUBMIT_PASSWORD_RESET_SUCCEEDED = 'ACTION_FORM_SUBMIT_SUCCEEDED'
export const SUBMIT_PASSWORD_RESET_FAILED = 'ACTION_FORM_SUBMIT_FAILED'
export const PREPARE_FORM_RESET = 'PREPARE_FORM_RESET'

// AcceptInvitation
export const ACCEPT_INVITATION_LOAD = 'ACCEPT_INVITATION_LOAD'
export const ACCEPT_INVITATION_LOAD_SUCCEEDED =
  'ACCEPT_INVITATION_LOAD_SUCCEEDED'
export const ACCEPT_INVITATION_LOAD_FAILED = 'ACCEPT_INVITATION_LOAD_FAILED'
export const ACCEPT_INVITATION_CONFIRM = 'ACCEPT_INVITATION_CONFIRM'
export const ACCEPT_INVITATION_CONFIRM_SUCCEEDED =
  'ACCEPT_INVITATION_CONFIRM_SUCCEEDED'
export const ACCEPT_INVITATION_CONFIRM_FAILED =
  'ACCEPT_INVITATION_CONFIRM_FAILED'

// FORM COMMON
export const FORM_SUBMIT_SUCCEEDED = 'ACTION_FORM_SUBMIT_SUCCEEDED'
export const FORM_SUBMIT_FAILED = 'ACTION_FORM_SUBMIT_FAILED'
export const FORM_EXECUTE_RECAPTCHA = 'FORM_EXECUTE_RECAPTCHA'

// Setup MFA WEB_AUTHN
export const PREPARE_WEB_AUTHN_REGISTRATION = 'PREPARE_WEB_AUTHN_REGISTRATION'
export const PREPARE_WEB_AUTHN_REGISTRATION_FAILED =
  'PREPARE_WEB_AUTHN_REGISTRATION_FAILED'
export const FINISH_WEB_AUTHN_REGISTRATION = 'FINISH_WEB_AUTHN_REGISTRATION'
export const FINISH_WEB_AUTHN_REGISTRATION_SUCCEEDED =
  'FINISH_WEB_AUTHN_REGISTRATION_SUCCEEDED'
export const FINISH_WEB_AUTHN_REGISTRATION_FAILED =
  'FINISH_WEB_AUTHN_REGISTRATION_FAILED'
export const REGISTER_WEB_AUTHN = 'REGISTER_WEB_AUTHN'
export const REGISTER_WEB_AUTHN_SUCCEEDED = 'REGISTER_WEB_AUTHN_SUCCEEDED'
export const REGISTER_WEB_AUTHN_FAILED = 'REGISTER_WEB_AUTHN_FAILED'

// Setup MFA TOTP
export const PREPARE_TOTP_REGISTRATION = 'PREPARE_TOTP_REGISTRATION'
export const PREPARE_TOTP_REGISTRATION_SUCCEEDED =
  'PREPARE_TOTP_REGISTRATION_SUCCEEDED'
export const PREPARE_TOTP_REGISTRATION_FAILED =
  'PREPARE_TOTP_REGISTRATION_FAILED'
export const FINISH_TOTP_REGISTRATION = 'FINISH_TOTP_REGISTRATION'
export const FINISH_TOTP_REGISTRATION_SUCCEEDED =
  'FINISH_TOTP_REGISTRATION_SUCCEEDED'
export const FINISH_TOTP_REGISTRATION_FAILED = 'FINISH_TOTP_REGISTRATION_FAILED'

// Settings
export const RECOVERY_OTPS_REGISTER = 'RECOVERY_OTPS_REGISTER'
export const RECOVERY_OTPS_REGISTER_SUCCEEDED =
  'RECOVERY_OTPS_REGISTER_SUCCEEDED'
export const RECOVERY_OTPS_REGISTER_FAILED = 'RECOVERY_OTPS_REGISTER_FAILED'
export const RECOVERY_OTPS_RENEW = 'RECOVERY_OTPS_RENEW'
export const REVOKE_ALL_MFA_MECHANISMS = 'REVOKE_ALL_MFA_MECHANISMS'
export const REVOKE_MFA_CONFIRMATION_DISMISSED =
  'REVOKE_MFA_CONFIRMATION_DISMISSED'
export const REVOKE_MFA_MECHANISM = 'REVOKE_MFA_MECHANISM'
export const REVOKE_MFA_MECHANISM_FAILED = 'REVOKE_MFA_MECHANISM_FAILED'
export const REVOKE_MFA_MECHANISM_SUCCEEDED = 'REVOKE_MFA_MECHANISM_SUCCEEDED'
export const ADD_MFA_MECHANISM_SUCCEEDED = 'ADD_MFA_MECHANISM_SUCCEEDED'
export const SELECT_MFA_TO_REVOKE = 'SELECT_MFA_TO_REVOKE'
